import { render, staticRenderFns } from "./ContractRemodelations.vue?vue&type=template&id=479f84a7&"
import script from "./ContractRemodelations.vue?vue&type=script&lang=js&"
export * from "./ContractRemodelations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports